import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, CardTitle, Drawer } from '@reveni-io/reveni-ui'

import EmailMetadata from './EmailMetadata/EmailMetadata'
import EmailPreview from './EmailPreview/EmailPreview'
import * as Styles from './styles'

const EmailNotificationDrawer = ({
  show,
  onClose,
  name,
  toName,
  to,
  created,
  subject,
  attachments,
  preview,
  fetchingPreview,
  onResend,
  resending,
  allowsResend,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <Styles.MainContainer>
        <CardTitle marginBottom="0">{t('Notificación de email')}</CardTitle>
        <EmailMetadata
          name={name}
          toName={toName}
          to={to}
          created={created}
          subject={subject}
          attachments={attachments}
        />
        <ButtonWithSpinner
          fullWidth
          variant="outlined"
          defaultLabel={t('Reenviar email')}
          loadingLabel={t('Reenviando')}
          onClick={onResend}
          loading={resending}
          disabled={resending || allowsResend === false}
        />
        <EmailPreview fetching={fetchingPreview} preview={preview} />
        <Button fullWidth variant="outlined" onClick={onClose}>
          {t('Cerrar')}
        </Button>
      </Styles.MainContainer>
    </Drawer>
  )
}

export default EmailNotificationDrawer
